import { type ReactNode } from "react"
import { cn } from "@/lib/utils"

type PageShellProps = {
  children: ReactNode
  className?: string
}

type SectionProps = {
  children: ReactNode
  className?: string
}

export function PageShell({ children, className }: PageShellProps) {
  return <div className={cn("relative isolate overflow-x-clip bg-background", className)}>{children}</div>
}

export function PageSection({ children, className }: SectionProps) {
  return <section className={cn("section-padding", className)}>{children}</section>
}

export function PageContainer({ children, className }: SectionProps) {
  return <div className={cn("container mx-auto px-4", className)}>{children}</div>
}
